export default {"src":"/_next/static/media/affirm.64621d51.svg","height":171,"width":429};